import axiosClient, { responseBody } from '@/api/axios-client';
import { getRecoil } from 'recoil-nexus';
import { pidState } from '@/use/usePidState';

export type JoinGameBody = {
  client_pid: string;
  display_name?: string;
};

export const postJoin = (token: string, body: JoinGameBody) => {
  return axiosClient
    .post(`/api/games/${encodeURIComponent(token)}/join`, body)
    .then(responseBody);
};

export const postMove = (token: string, body: { col: number }) => {
  const client_pid = getRecoil(pidState) || undefined;
  return axiosClient
    .post(`/api/games/${encodeURIComponent(token)}/moves`, {
      ...body,
      ...(client_pid ? { client_pid } : {}),
    })
    .then(responseBody);
};

export const postResign = (token: string) => {
  return axiosClient
    .post(`/api/games/${encodeURIComponent(token)}/resign`)
    .then(responseBody);
};

export const postRematch = (token: string) => {
  return axiosClient
    .post(`/api/games/${encodeURIComponent(token)}/rematch`)
    .then(responseBody);
};

export const postLeaveLobby = (token: string) => {
  return axiosClient
    .post(`/api/games/${encodeURIComponent(token)}/leave`)
    .then(responseBody);
};
